/*
 * ScreenBase
 * ==========
 */

export default class ScreenBase {

    constructor(game, placeholderTextures) {
        this.game = game;
        this.designerMode = false;

        this.params = {};
        this.texts = [];
        this.buttons = [];
        this.traced = [];

        this.view = game.make.group();

        this.fakeShaderReload = this.addText2('bg', 'blue', ' ', 1);
        if (this.designerMode && placeholderTextures) {
            this.placeholder = PARAMS.makeSprite(game, 0, 0, placeholderTextures);
            this.placeholder.anchor.set(0.5);
            this.view.add(this.placeholder)
        }
        this.view.alpha = 0;

        this.setInputForAllButtons(false);
    }

    setInputEnabledForButtons(enable) {
        for (var i = 0; i < this.buttons.length; i++) {
            this.buttons[i].inputEnabled = enable;
            this.buttons[i].frameName = this.buttons[i]._onOutFrame;
        }
    }

    forceOutForAllButtons() {
        for (var i = 0; i < this.buttons.length; i++) {
            this.buttons[i].frameName = this.buttons[i]._onOutFrame;
        }
    }

    onHideStarted() {
        this.setInputForAllButtons(false);
        // this.view.cacheAsBitmap = true
    }

    onHideEnded() {
        // this.view.cacheAsBitmap = false
    }

    onShowStarted() {
        // this.view.cacheAsBitmap = true
        this.updateTexts(this);
    }

    onShowEnded() {
        this.setInputForAllButtons(true);
        // this.view.cacheAsBitmap = false
    }

    addSprite(paramName, atlas, texture) {
        var x = 0;
        var y = 0;
        if (this.params[paramName]) {
            x = this.params[paramName][0] * PARAMS.scaleFactor;
            y = this.params[paramName][1] * PARAMS.scaleFactor
        }

        var sprite = PARAMS.makeSprite(this.game, x, y, atlas, texture);
        sprite.anchor.set(0.5);
        this.view.add(sprite);
        this.addDrag(sprite);

        this.traced.push(sprite);
        sprite.tracedName = paramName;
        return sprite;
    }

    /* addText (paramName, font, text, size, anchorX = 0.5) {
     console.trace()
     var x = 0
     var y = 0
     if (this.params[paramName]) {
     x = this.params[paramName][0] * PARAMS.scaleFactor
     y = this.params[paramName][1] * PARAMS.scaleFactor
     }

     var txt = this.game.make.bitmapText(x, y, font, text, size * PARAMS.scaleFactor, 'center')
     txt.anchor.set(0.5)
     this.view.add(txt)

     this.addDrag(txt)

     this.traced.push(txt)

     txt.tracedName = paramName

     txt.anchor.set(anchorX, 0.5)

     return txt
     }

     addTextButton (paramName, texture, text, action) {
     console.trace()
     var x = 0
     var y = 0
     if (this.params[paramName]) {
     x = this.params[paramName][0] * PARAMS.scaleFactor
     y = this.params[paramName][1] * PARAMS.scaleFactor
     }

     var normal = texture + '.png'

     var down = texture + 'Rollover.png'

     var button = null;

     var callback = function () {
     if ( button && button.worldAlpha === 0 ) {
     //console.log("Here stopped")
     return
     }
     action(this);
     AUDIO.playSound('buttonClick')
     }

     button = PARAMS.addButton(this.game, x, y, 'uiScreens', callback, this, normal, normal, down)

     button.anchor.set(0.5)

     this.addDrag(button)
     this.view.add(button)

     var txt = this.game.make.bitmapText(0, -13 * PARAMS.scaleFactor, 'main-big-blue', text, 26 * PARAMS.scaleFactor, 'center')
     txt.anchor.set(0.5, 0)
     button.addChild(txt)
     button.txt=txt

     this.traced.push(button)
     button.tracedName = paramName

     this.buttons.push(button)
     return button
     } */

    addText2(paramName, fontColor, text, size, anchorX = 0.5) {
        var x = 0;
        var y = 0;
        if (this.params[paramName]) {
            x = this.params[paramName][0] * PARAMS.scaleFactor;
            y = this.params[paramName][1] * PARAMS.scaleFactor
        }

        var font = PARAMS.getFonts(fontColor, size * PARAMS.scaleFactor);
        var txt = this.game.make.bitmapText(x, y, font, text, size * PARAMS.scaleFactor, 'center');
        txt.preferredFontSize = size * PARAMS.scaleFactor;
        txt.fontNameColor = fontColor;

        this.view.add(txt);
        this.addDrag(txt);
        this.traced.push(txt);

        txt.tracedName = paramName;
        txt.anchor.set(anchorX, 0.5);
        this.texts.push(txt);
        return txt;
    }

    addTextButton2(paramName, texture, text, action) {
        var x = 0;
        var y = 0;
        if (this.params[paramName]) {
            x = Math.round(this.params[paramName][0] * PARAMS.scaleFactor);
            y = Math.round(this.params[paramName][1] * PARAMS.scaleFactor);
        }

        var normal = texture + '.png';
        var down = texture + 'Rollover.png';
        var button = null;
        var that = this;

        var callback = function () {
            if ((button && button.worldAlpha === 0) || this.screens.activeScreen !== that) {
                return;
            }
            action(this);
            AUDIO.playSound('buttonClick')
        };

        button = PARAMS.addButton(this.game, x, y, 'uiScreens', callback, this, normal, normal, down);
        button.anchor.set(0.5);
        this.addDrag(button);
        this.view.add(button);

        var size = 26 * PARAMS.scaleFactor;
        var font = PARAMS.getFonts('blue', size);
        var txt = this.game.make.bitmapText(0, -13 * PARAMS.scaleFactor, font, text, size);

        txt.preferredFontSize = size;
        txt.fontNameColor = 'blue';
        txt.anchor.set(0.5, 0);
        this.texts.push(txt);

        button.addChild(txt);
        button.txt = txt;

        this.traced.push(button);
        button.tracedName = paramName;

        this.buttons.push(button);
        return button
    }

    addButton(paramName, texture, action) {
        var x = 0;
        var y = 0;
        if (this.params[paramName]) {
            x = this.params[paramName][0] * PARAMS.scaleFactor;
            y = this.params[paramName][1] * PARAMS.scaleFactor
        }

        var normal = texture + '.png';

        var down = texture + 'Rollover.png';

        var button = null;
        var that = this;

        var callback = function () {
            if ((button && button.worldAlpha === 0) || this.screens.activeScreen !== that) {
                // console.log("Here stopped")
                return
            }
            action(this);
            AUDIO.playSound('buttonClick')
        };

        button = PARAMS.addButton(this.game, x, y, 'uiScreens', callback, this, normal, normal, down);
        button.anchor.set(0.5);
        this.addDrag(button);
        this.view.add(button);

        this.traced.push(button);
        button.tracedName = paramName;
        this.buttons.push(button);

        return button;
    }

    updateTexts() {
        for (var i = 0; i < this.texts.length; i++) {
            var elem = this.texts[i];

            // elem.x = Math.round(elem.x)
            // elem.y = Math.round(elem.y)

            if (elem.preferredFontSize) {
                var newFont = PARAMS.getFonts(elem.fontNameColor, elem.worldScale.x * elem.preferredFontSize);
                // console.log(newFont, elem.preferredFontSize);
                elem.font = newFont
            }

            // elem.x -= elem.worldPosition.x - Math.floor(elem.worldPosition.x) ;
            // elem.y -= elem.worldPosition.y - Math.floor(elem.worldPosition.y) ;
            // console.log(elem.worldPosition.x, elem.worldPosition.y)
        }
    }

    setInputForAllButtons(enable) {
        for (var i = 0; i < this.buttons.length; i++) {
            this.buttons[i].inputEnabled = enable;
        }
    }

    addDrag(el) {
        if (!this.designerMode) return;
        el.inputEnabled = true;
        el.input.enableDrag(true);

        el.events.onDragStop.add(function () {
            // //console.log( Math.floor(el.x), Math.floor(el.y) )
            this.printTraced()
        }, this);

        el.events.onDragUpdate.add(function (sprite, pointer) {
            var pos = sprite.game.input.getLocalPosition(sprite.parent, pointer);

            if (sprite.hitArea) {
                sprite.x = pos.x - sprite.hitArea.width / 2;
                sprite.y = pos.y - sprite.hitArea.height / 2
            } else {
                sprite.x = pos.x - sprite.width / 2;
                sprite.y = pos.y - sprite.height / 2
            }
        })
    }

    printTraced() {
        var result = '{\n';
        for (var i = 0; i < this.traced.length; i++) {
            result += '\t\'' + this.traced[i].tracedName + '\': [' + Math.round(this.traced[i].x) + ', ' + Math.round(this.traced[i].y) + ']';
            if (i < this.traced.length - 1) result += ',\n';
            else result += '\n'
        }
        result += '}';

        // console.log(result)
    }

}
